import React, { createContext, useContext, useState } from 'react';

const WidgetBuilderContext = createContext();

export function WidgetBuilderProvider({ children }) {
  const [isEditing, setIsEditing] = useState(false);
  const [activeDragItem, setActiveDragItem] = useState(null);

  const toggleEditing = () => setIsEditing((prev) => !prev);

  return (
    <WidgetBuilderContext.Provider value={{
      isEditing,
      setIsEditing,
      toggleEditing,
      activeDragItem,
      setActiveDragItem
    }}>
      {children}
    </WidgetBuilderContext.Provider>
  );
}

export function useWidgetBuilder() {
  return useContext(WidgetBuilderContext);
}
